import React, { useState } from 'react'
import {
  Button,
  Icon,
  Popup
} from 'semantic-ui-react'
// Local
import {
  ENCOUNTER,
  shouldRenderReskin2025
} from '../../../constant'
import { Encounter } from '../../authenticated/types'
import ReveleerButton from '../../common/ReveleerButton'
import { ObjectValues } from '../../../types/types'

/**
 * Provides a component that renders an encounter cancel button. The component
 * includes support for both canceling and undoing the cancel
 * @param encounter Encounter entity
 * @param onClick Callback function for button click.
 *        Arguments: the updated status of the encounter
 * @param mode Render mode. Default: left
 */

type Props = {
  encounter: Encounter | undefined
  onClick: (encounterStatus: ObjectValues<typeof ENCOUNTER.STATUS>) => void
  mode?: string
}

function EncounterCancelButton(
  props: Props
): JSX.Element | null {
  const {
    encounter,
    onClick,
    mode = 'left'
  } = props
  const [
    encounterStatus,
    setEncounterStatus
  ] = useState<string | undefined>(
    encounter && encounter.status
      ? encounter.status
      : undefined
  )

  const handleOnClick = () => {
    const newStatus =
      encounterStatus === ENCOUNTER.STATUS.CANCELLED
        ? ENCOUNTER.STATUS.PLANNED
        : ENCOUNTER.STATUS.CANCELLED
    setEncounterStatus(newStatus)
    onClick(newStatus)
  }

  if (mode !== 'left') return null

  if (encounterStatus === ENCOUNTER.STATUS.CANCELLED) {
    return (
      <div className="ui segment attached compact left-segment">
        <div className="m-1-top m-1-bottom left-title-center">
          <Popup
            content="Mark Patient Encounter as Planned"
            mouseEnterDelay={ 1000 }
            trigger={
              shouldRenderReskin2025
                ? (
                  <ReveleerButton
                    buttonLabel="Undo Encounter Cancel"
                    buttonSize="small"
                    buttonType="secondary"
                    id="encounter-cancel-submit"
                    isDisabled={ false }
                    onClick={ handleOnClick }
                    type="submit"
                  />
                )
                : (
                  <Button
                    id="encounter-cancel-submit"
                    type="submit"
                    onClick={ handleOnClick }
                  >
                    <Icon name="undo" />
                    Undo Encounter Cancel
                  </Button>
                )
            }
          />
        </div>
      </div>
    )
  }

  return (
    <div className="ui segment attached compact left-segment">
      <div className="m-1-top m-1-bottom left-title-center">
        <Popup
          content="Mark Patient Encounter Cancelled"
          mouseEnterDelay={ 1000 }
          trigger={
            shouldRenderReskin2025
              ? (
                <ReveleerButton
                  buttonLabel="Cancel Encounter"
                  buttonSize="small"
                  buttonType="secondary"
                  id="encounter-cancel-submit"
                  isDisabled={ false }
                  onClick={ handleOnClick }
                  type="submit"
                />
              )
              : (
                <Button
                  id="encounter-cancel-submit"
                  type="submit"
                  onClick={ handleOnClick }
                >
                  <Icon name="trash" />
                  Cancel Encounter
                </Button>
              )
          }
        />
      </div>
    </div>
  )
}

export default EncounterCancelButton
